import { useState, useRef } from 'react';
import { IconDownload } from '@/shared/ui/Icons';
import { useIntl } from 'react-intl'
import Button from '@/shared/ui/Button';
import { formatChartDate } from '@/shared/utils/dateFormatters';
import { CSVLink } from "react-csv";

type DownloadCsvProps = {
  title: string;
  filename?: string;
  prepareData: () => void;
}

const DownloadCsv = (props: DownloadCsvProps) => {
  const {
    title = '',
    prepareData,
    filename = `file`,
  } = props;

  const intl = useIntl();
  const [data, setData] = useState<any>([]);
  const csvLink = useRef();

  const handleCsvDownload = async () => {
    if (typeof prepareData === 'function') {
      const loadedData = prepareData();
      setData(loadedData);
      // trigger download to the next tick
      setTimeout(() => {
        // @ts-ignore
        csvLink?.current?.link?.click();
      }, 0);
    }
  };

  const date = formatChartDate({ date: new Date(), locale: intl.locale });

  return (
    <>
      <CSVLink
        data={data}
        filename={`${filename} - ${date}.csv`}
        className="hidden"
        // @ts-ignore
        ref={csvLink}
        target="_blank"
      />
      <Button 
        onClick={handleCsvDownload}
        prefixIcon={<IconDownload/>}
      >
        {title}
      </Button>
    </>
  );
}

export default DownloadCsv;
